module.exports = __webpack_public_path__ + "static/media/ico-nav-close.600dd8a0.svg";